<div
  class="flex flex-col flex-wrap justify-center content-center items-center w-full">
  <img
    alt="{{ title }}"
    class="mb-4 {{ imageClass }}"
    src="{{ creative }}"
    [attr.width]="imageWidth" />
  <div [ngClass]="titleClass" class="mb-2 text-gray-800">{{ title }}</div>
  <span
    [ngClass]="descriptionClass"
    class="text-gray-800 text-center"
    [innerHTML]="description"></span>
</div>
